import { LTIState } from "./types";

const state: LTIState = {
  searchMode: "single",
  selectedMaterials: [],
};

export default state;
